import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'careerRequests';
export const careerRequestsActions = makeActions(
  MODEL_NAME,
  'id',
  'career-request',
);

export const getAllCareerRequests = careerRequestsActions.getAll;
export const editCareerRequests = careerRequestsActions.edit;
export const createCareerRequests = careerRequestsActions.create;
export const getByIdCareerRequests = careerRequestsActions.getDataById;
